
















































import { Component, Vue } from 'vue-property-decorator'
import { postDesigner } from '../../utils/http-client/designer-api'
import { Designer, generateEmptyDesigner } from '../../types/designers'
import MessageBus from '../../utils/buses/MessageBus'
import { requiredValidation } from '@/utils/validations'

@Component
export default class DesignersView extends Vue {
  private designer: Designer = generateEmptyDesigner()
  private designerFieldsList: string[] = []
  private valid: boolean = true
  private isSubmitting: boolean = false
  private rules: Object = {
    required: requiredValidation
  }

  created () {
    this.designerFieldsList = Object.keys(this.designer).map((key) => key)
  }
  private async onSubmit () {
    this.isSubmitting = true
    try {
      await postDesigner(this.designer)
    } catch (err) {
      console.error('Designer Sign Up Error', err)
      MessageBus.sendDefaultError()
    } finally {
      this.isSubmitting = false
    }
  }
}
